export default __webpack_public_path__ + "static/media/32.5164001a.jpg";